import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import { isInt, isNumber, isString, isFloat, isUndefined, isArray, isBoolean, isObject, get } from './try';
/**
 *  检测传入的值的类型是否正确
 */

export var checkType = function checkType(value, type) {
  var typeMap = {
    string: !isUndefined(value) && value !== 'not available' ? !isString(value) ? String(value) : value : '',
    number: isNumber(value) ? value : -1,
    int: isNumber(value) ? isInt(value) ? value : _parseInt(value) : -1,
    float: _parseFloat(value) || -0.0,
    'array|int': isArray(value) ? value.map(function (item) {
      return isInt(_parseInt(item)) ? _parseInt(item) : -1;
    }) : [],
    boolean: isBoolean(value) ? value ? 1 : 0 : isArray(value) && value.filter(function (item) {
      return !item || item === undefined;
    }).length > 1 ? 0 : value && value !== 'not available' && !isUndefined(value) ? 1 : 0,
    object: isObject(value) ? value : {}
  };
  return typeMap[type];
};
/**
 *  校验上报前的数据
 */

export var checkAllValues = function checkAllValues(values) {
  //协议上报一级字段
  var keys = ['country_id', 'app_brand', 'user_id', 'sdk_version', 'scenario_number', 'app_id', 'ajid', 'adid', 'device_id', 'uuid', 'ethIp', 'ipv6', 'location', 'broswer', 'sys_feature', 'resolution', 'webgl_attribute', 'font_display', 'os', 'color_depth', 'canvas', 'webgl', 'webgl_vendor_renderer', 'device_memory', 'pixel_ration', 'cpu_class', 'fonts', 'fonts_flash', 'audio', 'enumerate_devices', 'native_fingerprint', 'ext', 'post_timestamp', 'adjust_timestamp', 'conn', 'sd_ext', 'sup'];

  try {
    var uploadKeys = _Object$keys(values);

    var isEquar = keys.length === uploadKeys.length && keys.sort().toString() === uploadKeys.sort().toString(); // diff = keys.filter((i) => !uploadKeys.includes(i))

    if (!isEquar) console.error("\u4E0A\u62A5\u5B57\u6BB5\u4E0E\u534F\u8BAE\u4E0D\u4E00\u81F4\u8BF7\u68C0\u67E5"); //${JSON.stringify(diff)}
  } catch (e) {}
};
/**
 * @param {object} config 用户配置
 * @param {boolean} abbr 是否返回简写字段，传值true或不传
 */

export var filterConfigExtraValues = function filterConfigExtraValues(config, abbr) {
  return abbr ? {
    ci: checkType(get(config, 'extra.country_id'), 'int'),
    sn: checkType(get(config, 'extra.scenario_number'), 'int'),
    ab: checkType(get(config, 'extra.app_brand'), 'string'),
    adid: checkType(get(config, 'extra.google_ad_id'), 'string'),
    ajid: checkType(get(config, 'extra.adjust_id'), 'string'),
    ui: checkType(get(config, 'extra.user_id'), 'string'),
    ext: checkType(get(config, 'extra.ext'), 'object')
  } : {
    country_id: checkType(get(config, 'extra.country_id'), 'int'),
    scenario_number: checkType(get(config, 'extra.scenario_number'), 'int'),
    app_brand: checkType(get(config, 'extra.app_brand'), 'string'),
    user_id: checkType(get(config, 'extra.user_id'), 'string'),
    ajid: checkType(get(config, 'extra.adjust_id'), 'string'),
    adid: checkType(get(config, 'extra.google_ad_id'), 'string'),
    ext: checkType(get(config, 'extra.ext'), 'object')
  };
};
/**
 * 数组转字符串
 * @param {array} value
 */

export var arrayToString = function arrayToString(value) {
  var val = '';

  try {
    val = value.toString();
  } catch (e) {}

  return val || '';
};
/**
 * 获取随机字符串
 * @param {array} value
 */

export var randomString = function randomString(len, charSet) {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var str = '';

  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    str += charSet.substring(randomPoz, randomPoz + 1);
  }

  return str;
};
/**
 * 检验ip是否为正确格式
 * @param {array} value ip
 * @param {array} type 需要校验的格式，支持ipv4和ipv6，默认为ipv46同时满足
 */

export var validIP = function validIP(value) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ipv46';
  var val = false;
  var ipStr = /^(((\d{1,2})|(1\d{2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{2})|(2[0-4]\d)|(25[0-5]))$/; // ipv6正则参考：https://github.com/kriasoft/cloudflare-ips/blob/91a8be0a53fd8e1baf2a532102bd243e9cb5cbec/fetch.test.js

  var ipStr6 = /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/;

  function validIPv46(IP) {
    if (ipStr6.test(IP) || ipStr.test(IP)) {
      return true;
    }

    return false;
  }

  var valid = {
    ipv46: validIPv46(value),
    ipv4: ipStr.test(value),
    ipv6: ipStr6.test(value),
    ethip: isInnerIPFn(value)
  };

  try {
    val = valid[type];
  } catch (e) {}

  return val;
};
/**
 * 判断是否是内网IP
 * @param {array} value ip
 */

export var isInnerIPFn = function isInnerIPFn(ip) {
  var isInnerIp = false; //默认给定IP不是内网IP

  var ipNum = getIpNum(ip);
  /**
   * 私有IP：A类  10.0.0.0    -10.255.255.255
   *      B类  172.16.0.0  -172.31.255.255
   *      C类  192.168.0.0 -192.168.255.255
   *      D类  127.0.0.0  -127.255.255.255(环回地址)
   **/

  function getIpNum(ipAddress) {
    /*获取IP数*/
    var ip = ipAddress.split('.');

    var a = _parseInt(ip[0]);

    var b = _parseInt(ip[1]);

    var c = _parseInt(ip[2]);

    var d = _parseInt(ip[3]);

    var ipNum = a * 256 * 256 * 256 + b * 256 * 256 + c * 256 + d;
    return ipNum;
  }

  function isInner(userIp, begin, end) {
    return userIp >= begin && userIp <= end;
  }

  var aBegin = getIpNum('10.0.0.0');
  var aEnd = getIpNum('10.255.255.255');
  var bBegin = getIpNum('172.16.0.0');
  var bEnd = getIpNum('172.31.255.255');
  var cBegin = getIpNum('192.168.0.0');
  var cEnd = getIpNum('192.168.255.255');
  var dBegin = getIpNum('127.0.0.0');
  var dEnd = getIpNum('127.255.255.255');
  isInnerIp = isInner(ipNum, aBegin, aEnd) || isInner(ipNum, bBegin, bEnd) || isInner(ipNum, cBegin, cEnd) || isInner(ipNum, dBegin, dEnd);
  return isInnerIp;
};